import React from "react";
import PropTypes from "prop-types";
import { Layout } from "antd";
import { useTheme } from "../../contexts/ThemeContext";

const { Content } = Layout;

const PageLayout = ({ children, style, ...props }) => {
  const { theme, spacing } = useTheme();

  return (
    <Layout
      style={{
        height: "100dhv",
        backgroundColor: theme.white,
        ...style,
      }}
      {...props}
    >
      <Content
        style={{
          padding: `${spacing?.xl || 24}px`,
          backgroundColor: theme.background,
          color: theme.textSecondary,
        }}
      >
        {children}
      </Content>
    </Layout>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default PageLayout;
